import React from 'react';
import Typist from 'react-text-typist';
import styled, { createGlobalStyle } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNpm, faGithub } from '@fortawesome/free-brands-svg-icons';

const GlobalStyle = createGlobalStyle`
  
  :root {
    --app-height: 100%;
  }

  * {
    margin: 0;
    padding: 0;
    font-family: 'Montserrat', sans-serif;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent; /* Avoid blue square on tapping */
  }

   html {
    font-size: 62.5%; 
    box-sizing: border-box;
    height: 100%;
    --color-white: #f4f4f4;
    --color-black: #0A2027;
    --color-primary: #71E2A6;
    --color-translucid: #0a2027d8;
    --color-red: #ff5959;

    @media only screen and (max-width: 75em){
        font-size: 56.25%;
    }
    @media only screen and (max-width: 56.25em) {
        font-size: 50%;
    }
   }

  body {
    height: 100%;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--color-white);
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    line-height: 1.2;
    word-wrap: break-word;
    font-kerning: normal;
    background-color: #111111;
    -moz-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
    -ms-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
    -webkit-font-feature-settings: 'kern', 'liga', 'clig', 'calt';
    font-feature-settings: 'kern', 'liga', 'clig', 'calt';
  }

  #root{
    height: 100%;
    display: flex;
    flex-direction: column;
  }

`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem;
  flex: 1 0 auto;
`;

const Links = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 10rem;
`;

const Footer = styled.footer`
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem;

  a {
    color: var(--color-white);
    margin-left: 0.5rem;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <Content>
        <Typist
          style={{ fontSize: 20, fontWeight: 'bold' }}
          cursorClassName="myCursor"
          sentences={['Hi, this is React-Text-Typist.']}
          cursorColor={'#71E2A6'}
          loop={false}
          startDelay={1000}
          cursorDelay={0}
        ></Typist>
        <Typist
          style={{ fontSize: 15, fontWeight: 'bold', alignSelf: 'flex-start', marginTop: 20 }}
          cursorClassName="myCursor"
          sentences={['A simple component to create typing animations.']}
          loop={false}
          startDelay={3400}
          hideCursorOnFinish={true}
        ></Typist>
        <Typist
          style={{ fontSize: 15, fontWeight: 'bold', alignSelf: 'flex-start', marginTop: 40 }}
          cursorClassName="myCursor"
          sentences={['You can loop...', 'through multiple sentences.']}
          pauseTime={1000}
          startDelay={7500}
        ></Typist>
        <Typist
          style={{ fontSize: 15, fontWeight: 'bold', alignSelf: 'flex-start', marginTop: 40 }}
          cursorClassName="myCursor"
          sentences={['You can type very fast.']}
          loop={false}
          typingSpeed={10}
          deleteSpeed={10}
          startDelay={12500}
          hideCursorOnFinish={true}
        ></Typist>
        <Typist
          style={{ fontSize: 15, fontWeight: 'bold', alignSelf: 'flex-start', marginTop: 40 }}
          cursorClassName="myCursor"
          sentences={['Or very slow.']}
          loop={false}
          typingSpeed={400}
          startDelay={13000}
          hideCursorOnFinish={true}
        ></Typist>
        <Typist
          style={{
            fontSize: 16,
            fontWeight: 'bold',
            color: 'orange',
            alignSelf: 'flex-start',
            marginTop: 40,
          }}
          cursorColor={'red'}
          cursorClassName="myCursor"
          sentences={["It's fully customizable!!"]}
          loop={false}
          startDelay={14000}
        ></Typist>
      </Content>
      <Links>
        <a href="https://www.npmjs.com/package/react-text-typist">
          <FontAwesomeIcon
            style={{ fontSize: '10rem', color: '#cb3837' }}
            icon={faNpm}
          ></FontAwesomeIcon>
        </a>
        <a href="https://github.com/BraisC/react-text-typist">
          <FontAwesomeIcon
            style={{ fontSize: '7rem', color: 'var(--color-white)' }}
            icon={faGithub}
          ></FontAwesomeIcon>
        </a>
      </Links>
      <Footer>
        Made by <a href="https://braiscao.dev"> Brais Cao</a>
      </Footer>
    </>
  );
}

export default App;
